import { toCurrency } from '@/utils';
import { toFormattedDate } from '@/utils/date';
import { formatPaymentMethod } from '@/pages/reporting/paymentMethod';

export const SALARY_REPORT_PER_PAGE_OPTIONS = [25, 50, 100, 250];

export const SALARY_REPORT_FIELD_DEFINITIONS = [
  { key: 'full_name', label: 'Employee Name', sortable: true },
  { key: 'work_email', label: 'Email', sortable: true },
  {
    key: 'salary_completed_at',
    label: 'Salary completed',
    sortable: true,
    formatter: value => (value ? toFormattedDate(value, 'DD/MM/YYYY HH:mm') : '—'),
  },
  {
    key: 'salary_amount',
    label: 'Salary amount',
    sortable: true,
    formatter: value => toCurrency(value || 0),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  {
    key: 'payment_method',
    label: 'Payment method',
    sortable: false,
    formatter: (value, key, item) => formatPaymentMethod(item),
  },
];
